import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function Modal({ open, setOpen, children, className }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className={className}>{children}</DialogContent>
    </Dialog>
  );
}

Modal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

Modal.defaultProps = {
  open: false,
  setOpen: () => true,
  className: "",
};
